<template>
    <td
            class="watch-transition-width cell_width"
            ref="table-cell"
            :data-ref="cell_key"
    >
        <input
                :class="[
                {
            'invalid':is_invalid,
            },
            classes
           ]"
                :maxlength="max"
                :minlength="min"
                :type="set_type"
                :pattern="pattern"
                @blur="outBlur($event)"
                @focus="inFocus"
                @keyup.enter="validate"
                @keydown.tab="validate"
                ref="cell_input"
                v-model="cell"
                :title="title"
        >
    </td>

</template>

<script>
    import Vue from 'vue';
    import vueTooltip from "../../../../../../app/Shared/Resources/Assets/js/components/base/tooltip/vueTooltip";

    Vue.use(vueTooltip);
    export default {
        name: "TableCell",
        props: {
            title: {
                type: String
            },
            entry: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            rules: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            cell_key: {
                type: String,
                default: null
            },
            row_index: {
                type: Number,
                default: 0
            },
            is_invalid: {
                type: Boolean,
                default: false
            },
            use_focus: {
                type: Boolean,
                default: true
            },
            target_focus: {
                type: Boolean,
                default: true
            }
        },
        mounted() {
            this.init();
        },
        data() {
            return {
                edit: false,
                has_focus: false,
                set_type: 'text',
                pattern: false,
                classes: [],
                min: false,
                max: false,
                regex: false
            }
        },
        computed: {
            cell: {
                get: function () {
                    return this.entry[this.cell_key]
                },
                set: function (newCellValue) {
                    return newCellValue
                },
            },

        },
        methods: {
            outBlur(event){
                this.edit = false;
                if(event.target.value){
                    this.validate(event)
                }
            },
            inFocus(focus){
                this.has_focus = true;
            },
            init() {
                this.initRules();
            },
            initRules() {
                if (this.rules.type !== null) {
                    for (let i = 0; i < this.rules.type.length; i++) {
                        let thisType = this.rules.type[i];
                        switch (thisType) {
                            case 'lowercase':
                                this.classes.push('text-lowercase');
                                break;
                            case 'uppercase':
                                this.classes.push('text-uppercase');
                                break;
                            case 'integer':
                                this.set_type = 'number';
                                break;
                            case 'telephone':
                                this.set_type = 'tel';
                                break;
                            case 'email':
                                this.set_type = 'email';
                                break;

                            case 'regex':
                                break;

                        }
                    }
                }
            },

            inputType() {
                let type = 'text';
                for (let i = 0; i < this.rules.type.length; i++) {

                }
                switch (this.rules.type) {
                    case 'integer':
                        type = 'number';
                        break;

                    case 'email':
                        type = 'email';
                        break;

                    case 'regex':
                        type = 'text';
                        break;

                }
                return type;
            },
            /**
             * validate the field
             */
            validate($event) {
                let self = this,
                    value = $event.target.value;

                // if (value === null || value === '') {
                //     return;
                // }

                self.has_focus = false;
                self.$emit('input', {
                    cell_key: this.cell_key,
                    value: $event.target.value,
                    row_index: self.row_index
                });
                // find next tab
            },
            targetNextInvalidFieldOrSubmitButton() {

            }

        },
        watch: {
            target_focus(target) {
                if (target) {
                    target,this.$refs.cell_input.focus();
                }
            }
        }
    }
</script>
<style scoped>
    .cell_width {
        width: 8%;
    }

    .cell_width:focus {
        width: 50.333%;
    }

    .cell_width:focus-within {
        width: 50.333%;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/table/TableCell.vue?7de5e4bf